<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-13 09:16:22
-->
<template>
    <div ref="avatarRef" class="avatarContent">
        <a-dropdown>
            <div style="padding:5px;margin-right:20px;cursor:pointer">
                {{ userInfo.user_name }}
                <a-avatar v-if="avatarImg" :src="avatarImg" :size="44">
                    <template #icon><UserOutlined /></template>
                </a-avatar>
            </div>
            
            <template #overlay>
                <a-menu @click="handleMenuClick">
                    <a-menu-item key="0" @click=" changeAvatarVisible = true">
                        <component :is="$antIcons['EditOutlined']"></component> {{ $t('user.changeAvatar')}}   
                    </a-menu-item>
                    <a-menu-item key="1" @click="editPwdVisible = true">
                        <component :is="$antIcons['EditOutlined']"></component> {{ $t('user.editPassword')}}   
                    </a-menu-item>
                    <a-menu-item key="2" @click="logout">
                        <component :is="$antIcons['PoweroffOutlined']"></component> {{ $t('base.logout')}}   
                    </a-menu-item>
                </a-menu>
            </template>
        </a-dropdown>

        <!-- 修改密码 -->
        <a-modal 
            v-model:visible="editPwdVisible" 
            :title="t('user.editPassword')" 
            width="700px"
            @cancel="handleCancel"
            @ok="handleOk"
        >
            <a-form layout="vertical" :model="formState" v-bind="formItemLayout">
                <a-form-item :label="t('user.newPassword')" v-bind="validateInfos.new_password">
                    <a-input-password v-model:value="formState.new_password" :placeholder="t('base.enter')" />
                </a-form-item>
                <a-form-item :label="t('user.confirm_password')" v-bind="validateInfos.confirm_password">
                    <a-input-password v-model:value="formState.confirm_password" :placeholder="t('base.enter')" />
                </a-form-item>
            </a-form>
        </a-modal>

        <!-- 更换头像 -->
        <a-modal 
            v-model:visible="changeAvatarVisible" 
            :title="t('user.changeAvatar')" 
            width="500px"
            :getContainer="getContainer"
            :footer="null"
            @ok="handleOk"
        >
            <a-upload
                v-model:file-list="fileList"
                name="file"
                list-type="picture-card"
                class="avatar-uploader"
                :show-upload-list="false"
                accept=".jpg,.jpeg,.png"
                :action="action"
                :headers="headers"
                @change="handleChange"
            >
                <img v-if="imageUrl" :src="imageUrl" alt="avatar" width="70"/>
                <div v-else>
                    <loading-outlined v-if="loading"></loading-outlined>
                    <plus-outlined v-else></plus-outlined>
                    <div class="ant-upload-text">上传头像</div>
                </div>
            </a-upload>
            <a-button class="login_btn" type="primary" @click.prevent="changeAvatarVisible = false">{{ $t('base.confirm2') }}</a-button>
        </a-modal>
    </div>
</template>

<script setup>
    import { ref, reactive, onMounted, watch } from "vue";
    import {useRouter} from 'vue-router';
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { UserApi } from '@/api/UserApi.js';
    import { globalView } from '@/store/global';
    import { Form } from 'ant-design-vue';
    
    const router = useRouter()
    const {t} = useI18n()
    const i18n = useI18n()

    const useForm = Form.useForm
    const userInfo = ref(JSON.parse(localStorage.getItem('hd_ota_loginUser')))
    const action = import.meta.env.VITE_BASE_URL + `/v1/page/users/${userInfo.value.id}/avatar`
    const headers = {
        'Authorization':  'Bearer ' + localStorage.getItem('hd_ota_token'),
    }

    const userName = ref('')
    const lang = ref(localStorage.getItem('lang')? localStorage.getItem('lang') : 'zh')
    const avatarRef = ref(null)
    const editPwdVisible = ref(false)
    const changeAvatarVisible = ref(false)
    const avatarImg = ref('')
    const fileList = ref([])
    const imageUrl = ref('')
    const loading = ref(false)
    const formState = reactive({
        new_password:'',
        confirm_password:'',
    })

    const rulesRef = reactive({
        new_password: [
            {
                required: true,
                message: '请输入新密码',
            },
        ],
        confirm_password: [
            {
                required: true,
                message: '请输入确认密码',
            },
        ],
    });

    const getContainer = ()=>{
        return avatarRef.value
    }

    // 上传固件回调
    const handleChange = (info)=>{
        console.log(info,'valllll')
        if (info.file.status === 'uploading') {
            loading.value = true;
            return;
        }
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, base64Url => {
                imageUrl.value = base64Url;
                loading.value = false;
            });

            getUserInfo()
        }
        if (info.file.status === 'error') {
            loading.value = false;
            message.error('upload error');
        }
    }

    const getBase64 = (img, callback) =>{
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    // 获取用户信息
    const getUserInfo = async ()=>{
        let res = await UserApi.getInstance().getUserInfo(userInfo.value.id)
        if (res.code == 0) {
            avatarImg.value = res.data.avatar.avatar_url
        } else {
            message.error(res.msg);
        }
    }

    // 修改密码
    const { resetFields, validate, validateInfos } = useForm(formState, rulesRef, {});
    const handleOk = ()=>{
        validate().then(async () => {
            let reg_pwd = /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{6,10}$/
            if(!reg_pwd.test(formState.new_password)){
                message.error('新密码格式不正确。密码长度6-10位，英文字母混合数字！');
                return
            }else if(!reg_pwd.test(formState.confirm_password)){
                message.error('确认密码格式不正确。密码长度6-10位，英文字母混合数字！');
                return
            }else if(formState.new_password != formState.confirm_password){
                message.error('新密码与确认密码不一致！');
                return
            }

            let param = {
                new_password: formState.new_password
            }
            let res = await UserApi.getInstance().editPasswordByUser(param, userInfo.value.id)
            if (res.code == 0) {
                Modal.warning({
                    title:t('base.tip'),
                    content:'密码修改成功！请重新登录',
                    okText:t('base.confirm'),
                    cancelText:t('base.cancel'),
                    onOk(){
                        router.push('/Login')
                        localStorage.removeItem('hd_ota_token')
                        localStorage.removeItem('hd_ota_loginUser')
                        localStorage.removeItem('hd_ota_rememberPwd')
                    },
                })
            } else {
                message.error(res.msg);
            }
        }).catch(err => {
            console.log('error', err);
        })
    }
    const handleCancel = ()=>{
        resetFields()
    }
    
    // 退出登录
    const logout = ()=>{
        Modal.confirm({
            title:t('base.tip'),
            content:t('base.logoutMsg'),
            okText:t('base.confirm'),
            cancelText:t('base.cancel'),
            onOk(){
                router.push('/Login')
                localStorage.removeItem('hd_ota_token')
                localStorage.removeItem('hd_ota_loginUser')
            },
        })
    }

    watch(()=>avatarImg.value,(oval,nval)=>{
        console.log(oval, nval,' vvbbb')
    })

    onMounted(()=>{
        getUserInfo()
    })
</script>

<style lang="scss" scoped>
.avatarContent{
    .ant-dropdown-link{
        width: 90px;
        color: #333;
    }

    .lang{
        margin-right: 20px;
    }
    .screenfull{
        margin: 2px 25px 0;
        line-height: inherit;
    }
    ::v-deep .ant-select-single:not(.ant-select-customize-input) .ant-select-selector{
        height: 25px;
    }
    ::v-deep .ant-select-single .ant-select-selector .ant-select-selection-item{
        line-height: 23px;
    }
}

::v-deep .ant-modal-body{
    text-align: center;
}

.login_btn{
    margin: 10px 0 0 -8px;
    width: 104px;
}
</style>